// This mixin is used to build queries to be sent to GraphQL resolver

import map from 'lodash/map'
import size from 'lodash/size'
import lt from 'lodash/lt'
import gt from 'lodash/gt'

export default {
  methods: {
    // TODO: Now seeing the actual usage and essential difference of the queries
    //       I would rather reduce this method a go with raw declaration of the query
    //       in each place where it is used. I think it would be more obvious.
    getQuery (tuples, resolver, schema) {
      const resolverParams = tuples.map(({ key, value }) => `${key}: ${value}`).join(', ')
      const resolverWithParams = `${resolver}(${resolverParams})`

      let query = resolverWithParams

      if (schema) {
        query = `
          ${resolverWithParams} {
            ${schema}
          }
        `
      }

      return query
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/dashboard/widgets/widgets/mixins/WidgetQueryMixin.js